import type { Provider } from '@angular/core';
import { DefaultLocale } from '@app/+authenticated/shared/locale/locale.helper';
import { KnowledgeBaseOptions } from '@sb/shared/knowledge-base';
import { environment } from 'src/environments/environment';

export const provideKnowledgeBaseOptions = (): Provider => ({
  provide: KnowledgeBaseOptions,
  useFactory: (): KnowledgeBaseOptions => ({
    baseUrl: environment.knowledgeBaseUrl,
    getLocale: () => localStorage.getItem('locale') ?? DefaultLocale,
  }),
});
